import { useQuery } from '@tanstack/react-query';
import { useCurrentUser } from '@/features/users/users.hooks';
import { dayPlanningQueries } from '../dayplanning/dayplanning.queries';

/**
 * Fetch workorders for a week-centric view.
 * `weekStart` must be the ISO Monday of the selected week (yyyy-MM-dd).
 * If `userId` is null, the current logged-in user is used.
 */
export function useMyWeekWorkorders(userId: number | null, weekStart: string) {
  const currentUser = useCurrentUser();
  const effectiveUserId = userId ?? currentUser?.recnum ?? 0;

  return useQuery({
    ...dayPlanningQueries.week(effectiveUserId, weekStart),
    enabled: effectiveUserId > 0,
  });
}

/**
 * Fetch workorders for a month-centric view.
 * `monthStart` must be the first day of the month (yyyy-MM-dd).
 * If `userId` is null, the current logged-in user is used.
 */
export function useMyMonthWorkorders(
  userId: number | null,
  monthStart: string,
) {
  const currentUser = useCurrentUser();
  const effectiveUserId = userId ?? currentUser?.recnum ?? 0;

  return useQuery({
    ...dayPlanningQueries.month(effectiveUserId, monthStart),
    enabled: effectiveUserId > 0,
  });
}
